import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createAdvertisement,
  getAdvertisement,
  resetState,
  updateAdvertisement,
} from "../features/Advertisement/AdvertisementSlice";
let schema = yup.object().shape({
  place: yup.string().required("Name is Required"),
  hitUrl: yup.string().required("Url is Required"),
  image: yup.mixed().required("Image is Required"),
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.advertisement);
  const [imageErrorone, setImageErrorone] = useState("");
    const {
    isSuccess,
    isError,
    isLoading,
    createdAdvertisement,
    updatedAdvertisement,
    Advertisementsplace,
    AdvertisementhitUrl
  } = newNewsCategory;
  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getAdvertisement(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createdAdvertisement) {
      toast.success("Advertisement Added Successfullly!");
      navigate("/admin/Advertisement-list");
    }
    if (isSuccess && updatedAdvertisement) {
      toast.success("Advertisement Updated Successfullly!");
      navigate("/admin/Advertisement-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      place: Advertisementsplace || "",
      hitUrl: AdvertisementhitUrl || "",
      image: null,
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("place", values.place);
      formData.append("hitUrl", values.hitUrl);
      formData.append("image", values.image);
      formData.append("id",getNewsCatId);
      if (getNewsCatId !== undefined) {
        dispatch(updateAdvertisement(formData));
        dispatch(resetState());
      } else {
        dispatch(createAdvertisement(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Advertisement
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="place"
            onChng={formik.handleChange("place")}
            onBlr={formik.handleBlur("place")}
            val={formik.values.place}
            label="Enter place"
          />
          <div className="error">
            {formik.touched.place && formik.errors.place}
          </div>

    
          <CustomInput
            type="text"
            name="hitUrl"
            onChng={formik.handleChange("hitUrl")}
            onBlr={formik.handleBlur("hitUrl")}
            val={formik.values.hitUrl}
            label="Enter Url"
          />
          <div className="error">
            {formik.touched.hitUrl && formik.errors.hitUrl}
          </div>


        
          <div className="mt-4">
            <label htmlFor="image" className="form-label">Select All Advertisement Image Four this Location</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue("image", e.currentTarget.files[0]);
                setImageErrorone(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.image && formik.errors.image}</div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} Advertisement
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
